<template>
  <div v-if="$auth.check()">
    <div class="mb-4">
      <h1>Olá<span v-if="username">, {{ username }}</span></h1>
      <div class="text-subtitle-1 text--secondary">Visão geral</div>
    </div>

    <!-- cards de totais -->
    <v-row>
      <v-col cols="12" sm="6" md="3">
        <v-card outlined hover style="cursor: pointer" @click="go('/client')">
          <v-card-text class="d-flex align-center">
            <v-icon size="40" color="primary" class="mr-4">mdi-account-multiple</v-icon>
            <div>
              <div class="text-h5 font-weight-bold">{{ format(clientes) }}</div>
              <div class="text-caption text--secondary">Clientes</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card outlined hover style="cursor: pointer" @click="go('/contract')">
          <v-card-text class="d-flex align-center">
            <v-icon size="40" color="primary" class="mr-4">mdi-file-document</v-icon>
            <div>
              <div class="text-h5 font-weight-bold">{{ format(contratos) }}</div>
              <div class="text-caption text--secondary">Contratos</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card outlined hover style="cursor: pointer" @click="go('/afiliado')">
          <v-card-text class="d-flex align-center">
            <v-icon size="40" color="primary" class="mr-4">mdi-handshake</v-icon>
            <div>
              <div class="text-h5 font-weight-bold">{{ format(afiliados) }}</div>
              <div class="text-caption text--secondary">Afiliados</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-card outlined hover style="cursor: pointer" @click="go('/lead')">
          <v-card-text class="d-flex align-center">
            <v-icon size="40" color="primary" class="mr-4">mdi-inbox-arrow-down</v-icon>
            <div>
              <div class="text-h5 font-weight-bold">{{ format(leads.length) }}</div>
              <div class="text-caption text--secondary">Leads · {{ monthLabel }}</div>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- leads do mes + ultimos leads -->
    <v-row class="mt-2">
      <v-col cols="12" md="4">
        <v-card outlined>
          <v-card-title class="text-subtitle-1">Leads de {{ monthLabel }}</v-card-title>
          <v-divider></v-divider>
          <v-simple-table>
            <tbody>
              <tr>
                <th class="text-left">
                  <v-icon small color="success" class="mr-1">mdi-web</v-icon>Site
                </th>
                <td class="text-right">{{ leadsSite }}</td>
              </tr>
              <tr>
                <th class="text-left">
                  <v-icon small color="warning" class="mr-1">mdi-account-arrow-right</v-icon>Indicação
                </th>
                <td class="text-right">{{ leadsIndicacao }}</td>
              </tr>
              <tr>
                <th class="text-left font-weight-bold">Total</th>
                <td class="text-right font-weight-bold">{{ leads.length }}</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card outlined>
          <v-card-title class="text-subtitle-1">Top indicadores · {{ monthLabel }}</v-card-title>
          <v-divider></v-divider>
          <v-simple-table>
            <tbody>
              <tr v-for="(item, i) in topIndicadores" :key="item.nome">
                <td class="text-center" style="width: 40px">{{ medal(i) }}</td>
                <td>{{ item.nome }}</td>
                <td class="text-right font-weight-bold">{{ item.total }}</td>
              </tr>
              <tr v-if="!topIndicadores.length">
                <td class="text--secondary">Nenhuma indicação neste mês</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card outlined>
          <v-card-title class="text-subtitle-1">Últimos leads</v-card-title>
          <v-divider></v-divider>
          <v-simple-table>
            <tbody>
              <tr v-for="item in latestLeads" :key="item.id">
                <td>{{ item.name }}</td>
                <td class="text-right text--secondary">{{ formatDate(item.created) }}</td>
              </tr>
              <tr v-if="!latestLeads.length">
                <td class="text--secondary">Nenhum lead neste mês</td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../api/index.js";
import router from "../router/index.js";
export default {
  data: () => ({
    clientes: 0,
    contratos: 0,
    afiliados: 0,
    leads: [],
    selectedMonth: "",
    loading: false,
  }),
  computed: {
    username: function () {
      var u = this.$auth.user();
      return u ? u.username : "";
    },
    // "2026-06" -> "06/2026"
    monthLabel: function () {
      if (!this.selectedMonth) return "";
      const [year, month] = this.selectedMonth.split("-");
      return `${month}/${year}`;
    },
    leadsSite: function () {
      return this.leads.filter(function (i) {
        return i.origin == 1;
      }).length;
    },
    leadsIndicacao: function () {
      return this.leads.filter(function (i) {
        return i.origin == 2;
      }).length;
    },
    // ranking de quem mais indicou no mes: agrupa pelo campo indicacao (nome do afiliado)
    topIndicadores: function () {
      var counts = {};
      this.leads.forEach(function (l) {
        var nome = (l.indicacao || "").trim();
        if (!nome) return;
        counts[nome] = (counts[nome] || 0) + 1;
      });
      return Object.keys(counts)
        .map(function (nome) {
          return { nome: nome, total: counts[nome] };
        })
        .sort(function (a, b) {
          return b.total - a.total;
        })
        .slice(0, 5);
    },
    // 5 leads mais recentes do mes (created em ISO ordena lexicograficamente)
    latestLeads: function () {
      return this.leads
        .slice()
        .sort(function (a, b) {
          return (b.created || "").localeCompare(a.created || "");
        })
        .slice(0, 5);
    },
  },
  created: function () {
    const now = new Date();
    const month = (now.getMonth() + 1).toString().padStart(2, "0");
    this.selectedMonth = `${now.getFullYear()}-${month}`;
    this.load();
  },
  methods: {
    go: function (path) {
      router.push({ path: path });
    },
    medal: function (index) {
      var medals = ["🥇", "🥈", "🥉"];
      return medals[index] || index + 1 + "º";
    },
    load: function () {
      var me = this;
      var auth = { headers: { Authorization: "Bearer " + localStorage.getItem("token") } };
      var period = me.selectedMonth.replace("-", ""); // "2026-06" -> "202606"
      me.loading = true;
      // cada chamada trata seu erro para o Promise.all nunca rejeitar
      Promise.all([
        api.get("/client/count", auth).then(function (r) { me.clientes = r.data; }).catch(function () {}),
        api.get("/contract/count", auth).then(function (r) { me.contratos = r.data; }).catch(function () {}),
        api.get("/afiliado", auth).then(function (r) { me.afiliados = (r.data || []).length; }).catch(function () {}),
        api.get("/lead/month/" + period, auth).then(function (r) { me.leads = r.data || []; }).catch(function () {}),
      ]).then(function () {
        me.loading = false;
      });
    },
    format: function (value) {
      return Number(value || 0).toLocaleString("pt-BR");
    },
    formatDate: function (date) {
      if (!date) return "";
      date = date.substring(0, date.indexOf("T"));
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
